// Safe HTML sanitization function
function sanitizeHtml(str) {
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
}

// Safe element creation function
function createDigitElement(char, className = '', style = '') {
    const digitDiv = document.createElement('div')
    digitDiv.className = `digit ${className}`
    
    const span = document.createElement('span')
    span.className = 'old'
    span.textContent = char
    if (style) {
        span.style.cssText = style
    }
    
    digitDiv.appendChild(span)
    return digitDiv
}

// Safe element creation for animated digits
function createAnimatedDigitElement(char, oldChar, className = '', newStyle = '', oldStyle = '') {
    const digitDiv = document.createElement('div')
    digitDiv.className = `digit ${className}`
    
    const newSpan = document.createElement('span')
    newSpan.className = 'new'
    newSpan.textContent = char
    if (newStyle) {
        newSpan.style.cssText = newStyle
    }
    
    const oldSpan = document.createElement('span')
    oldSpan.className = 'old'
    oldSpan.textContent = oldChar
    if (oldStyle) {
        oldSpan.style.cssText = oldStyle
    }
    
    digitDiv.appendChild(newSpan)
    digitDiv.appendChild(oldSpan)
    return digitDiv
}

export const vOdometer = {
    mounted(el, number) {
        if (number) {
            // Get array
            let numberArr = number.value.toFixed(10).split('')

            // Clear existing content
            el.innerHTML = ''

            // Generate base html using safe DOM methods
            numberArr.forEach(char => {
                const digitElement = createDigitElement(char)
                el.appendChild(digitElement)
            })
        }
    },

    updated(el, number) {
        // Get array
        let numberArr = number.value.toFixed(10).split(''),
            oldNumberArr = number.oldValue?.toFixed(10).split('') || [],
            maxLength = Math.max(numberArr.length, oldNumberArr.length),
            mismatchIndex = null,
            mismatchCount = 0,
            animationDuration = 1500,
            animationDelay = 50

        // Pad arrays with empty strings to maximum length
        numberArr = numberArr.concat(Array(maxLength - numberArr.length).fill(''))
        oldNumberArr = oldNumberArr.concat(Array(maxLength - oldNumberArr.length).fill(''))

        // Clear existing content
        el.innerHTML = ''

        // Generate elements using safe DOM methods
        numberArr.forEach((char, i) => {
            // Get mismatch
            if (mismatchIndex === null && char !== oldNumberArr[i]) {
                mismatchIndex = i
                mismatchCount = maxLength - i
                animationDuration = animationDuration - animationDelay * mismatchCount
            }

            // Calc animation
            let duration = 0
            if (mismatchIndex !== null) {
                duration = animationDuration / mismatchCount / 1000
            }

            const shouldAnimate = mismatchIndex !== null && i >= mismatchIndex
            const className = shouldAnimate ? 'animate' : ''
            const animationStyle = `animation-duration: ${parseFloat(duration.toFixed(2))}s; animation-delay: ${animationDelay * (i - mismatchIndex) / 1000}s;`

            if (shouldAnimate) {
                const digitElement = createAnimatedDigitElement(
                    char, 
                    oldNumberArr[i], 
                    className, 
                    animationStyle, 
                    animationStyle
                )
                el.appendChild(digitElement)
            } else {
                const digitElement = createDigitElement(char, className)
                el.appendChild(digitElement)
            }
        })
    }
}